import { getLocalUserData } from "@/utils";
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import chatReducer from "./slices/chatSlice";
import jobReducer from "./slices/jobSlice";
import meetingReducer from "./slices/meetingSlice";
import notificationReducer from "./slices/notificationSlice";
import purchaseReducer from "./slices/purchaseSlice";
import packageReducer from "./slices/packageSlice";
import languageReducer from "./slices/languageSlice";
import sidebarReducer from "./slices/sidebarSlice";

const reducers = {
  auth: authReducer,
  meeting: meetingReducer,
  chat: chatReducer,
  job: jobReducer,
  notification: notificationReducer,
  purchase: purchaseReducer,
  packages: packageReducer,
  language: languageReducer,
  sidebar: sidebarReducer
};

export const store = configureStore({
  reducer: reducers,
  preloadedState: { auth: { userData: getLocalUserData() } },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
